import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import { CLASSNAME, DEFAULT_INFO_PANEL_KIND, INFO_PANEL } from '../../constants';
import type { InfoPanelElement } from '../../types';

export const INFO_PANEL_ELEMENTS: HTMLSerializeOptions['elements'] = {
    [INFO_PANEL]: (node: InfoPanelElement, children) => {
        const kind = escapeHTML(node.kind || DEFAULT_INFO_PANEL_KIND);
        return `<div class="${CLASSNAME}" data-kind="${kind}">${children}</div>`;
    },
};
